type TMetadata = Record<string, string>

export interface OrganizationPayload {
  name: string
  metadata?: TMetadata
}

export interface Organization {
  id: string
  orgUserId: string
  ownerId: string
  name: string
  creatorId: string
  metadata?: TMetadata
  ownerUsername: string
  creatorUsername: string
}

export enum EPermissions {
  UpdateOrganization = 'update_organization',
  WalletsView = 'wallets_view',
  WalletsWrite = 'wallets_write',
  WalletsTransfer = 'wallets_transfer',
  TemplatesView = 'templates_view',
  TemplatesWrite = 'templates_write',
}

export type TPermissions = `${EPermissions}`

export interface CreateMemberPayload {
  username?: string
  email?: string
  organizationId: string
  permissions: TPermissions[]
}

export interface Member {
  memberId: string
  memberUsername: string
  memberFirstName: string
  memberLastName: string
  permissions: TPermissions[]
  organization: Organization
}

export interface OrganizationWalletsFilter {
  currency: string
  excludeEmpty: boolean
}
